import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background-color: #F5F5F5;
  padding-bottom: 80px;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const TabContainer = styled.div`
  display: flex;
  background: white;
  border-bottom: 1px solid #E5E5E5;
`;

export const Tab = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 16px;
  background: transparent;
  border: none;
  font-size: 16px;
  font-weight: ${props => props.active ? '600' : '400'};
  color: ${props => props.active ? '#333' : '#999'};
  cursor: pointer;
  position: relative;
  transition: all 0.2s;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: ${props => props.active ? '#1FBC70' : 'transparent'};
    transition: background 0.2s;
  }
`;

export const Content = styled.div`
  padding: 16px;
`;

export const ReviewCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ReviewDate = styled.div`
  font-size: 14px;
  color: #666;
  padding-bottom: 12px;
  margin-bottom: 12px;
  text-align: left;
  border-bottom: 1px solid #F0F0F0;
`;

export const ReviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #F0F0F0;
`;

export const ReviewCreatedDate = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const StarRating = styled.div`
  display: flex;
  gap: 2px;
  color: #FFC107;
  font-size: 16px;
`;

export const MoreButton = styled.button`
  background: transparent;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 4px;
  line-height: 1;

  &:hover {
    color: #666;
  }
`;

export const ReviewText = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  text-align: left;
  margin-top: 4px;
`;

export const ReviewContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  position: relative;
`;

export const FacilityImage = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const FacilityImagePlaceholder = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  flex-shrink: 0;
`;

export const FacilityInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
`;

export const FacilityName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: left;
`;

export const FacilityLocation = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const WriteReviewButton = styled.button`
  background: #1FBC70;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  align-self: flex-end;

  &:hover {
    background: #1AAA64;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 14px;
`;

export const ModalOverlay = styled.div<{ isOpen: boolean }>`
  display: ${props => props.isOpen ? 'block' : 'none'};
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const ModalContent = styled.div<{ isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) ${props => props.isOpen ? 'translateY(0)' : 'translateY(100%)'};
  width: 100%;
  max-width: 480px;
  background: white;
  border-radius: 20px 20px 0 0;
  padding: 24px;
  z-index: 1001;
  transition: transform 0.3s ease-in-out;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  padding: 0;
  line-height: 1;
`;

export const MenuItem = styled.button`
  width: 100%;
  background: transparent;
  border: none;
  padding: 20px 0;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid #F0F0F0;
  transition: background 0.2s;

  &:hover {
    background: #F5F5F5;
  }

  &:last-child {
    border-bottom: none;
  }
`;
